
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiManual as ObiManualElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-manual.js';
 
 
 

 
 export const ObiManual = createComponent({
   react: React,
   tagName: 'obi-manual',
   elementClass: ObiManualElement,
   events: {
     
   }
  });
 
 